import { render } from "./TagGroup.vue?vue&type=template&id=6028450e"
import script from "./TagGroup.vue?vue&type=script&lang=js"
export * from "./TagGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__